export default __webpack_public_path__ + "static/media/about_2.45ae7639.jpg";